import { ref } from "config/constants";
import { TOGGLE_LEFT, TOGGLE_RIGHT } from "./types";

export function toggleLeft() {
  return { type: TOGGLE_LEFT };
}

export function toggleRight() {
  return { type: TOGGLE_RIGHT };
}

export function closeLeft() {
  return { type: TOGGLE_LEFT, open: false };
}

export function closeRight() {
  return { type: TOGGLE_RIGHT, open:false };
}



// WEBPACK FOOTER //
// ./src/data/menus/actions.js